import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 系统配置（/v1/admin/system-config/**）
 */

export function listSystemConfig() {
  return axios.get(`${base.url}/service/v1/admin/system-config`)
}

export function updateSystemConfig(key, value) {
  return axios.put(`${base.url}/service/v1/admin/system-config/${key}`,
    JSON.stringify({ value }), { headers: { 'Content-Type': 'application/json' } })
}